import Banner from "../../components/Evaluation/Banner";
import EvaluationForm from "../../components/Evaluation/EvaluationForm";

const data = {
  title: "Ready to Unlock Your Startup’s True Potential?",
  desc: "Complete our quick evaluation form to get personalized insights and expert guidance. Whether you’re just starting out or scaling up, we’re here to help you grow smarter and faster.",
  src: "/evaluation1.svg",
};
const Evaluation = () => {
  return (
    <div style={{ fontFamily: "Inter" }}>
      <Banner data={data} />
      <EvaluationForm />
    </div>
  );
};

export default Evaluation;
